export default {

  namespaced: true,

  state: () => ({

    categories: {},
    category: {},

  }),

  mutations: {
    setCategories(state, data) {
      state.categories = data.data
    },

    setCategory(state, data) {
      state.category = data
    },

  },

  actions: {
    async getCategories({ dispatch, commit }, params) {
      await axios.get("/erp/category/category", { params: params })
        .then(response => {
          commit('setCategories', response)
        }).catch(error => { console.log(error)})
    },

    async getCategory({ dispatch, commit }, id) {
      await axios.get("/erp/category/category/" + id)
        .then(response => {
          commit('setCategory', response.data)
        }).catch(error => {console.log(error) })
    },

    async storeCategory({ $axios, commit }, params) {
      await axios.post("/erp/category/category", params)
        .then(response => {
         })
        .catch(error => { console.log(error)})
    },
  }
}
